import { Component, inject, OnInit } from '@angular/core';
import { LowerCasePipe } from '@angular/common';
import { InfiniteCarouselComponent } from "../../shared/infinite-carousel/infinite-carousel.component";
import { Router, RouterLink } from '@angular/router';
import { APP_PATHS } from '../../constants/routes.constants';
import { TranslateModule } from '@ngx-translate/core';
import { CATEGORIES } from '../../../assets/data/categories';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
  imports: [InfiniteCarouselComponent, RouterLink, TranslateModule, LowerCasePipe]
})
export class HomeComponent {
  paths = APP_PATHS;
  private dataService = inject(DataService);
  private router = inject(Router);
  animating: boolean = false;
  categories = CATEGORIES;

  // Mapa de código de categoría a OBJECTID aleatorio para las imágenes
  randomImages: Map<string, number> = new Map();


  ngOnInit(): void {
    this.loadRandomImages();
  }

  loadRandomImages(): void {
    this.dataService.getRandomCategories().subscribe(randomCategories => {
      randomCategories.forEach(rc => {
        this.randomImages.set(rc.categoria.toLowerCase(), rc.OBJECTID);
      });
    });
  }

  getBackgroundImage(code: string): string {
    const objectId = this.randomImages.get(code.toLowerCase());
    if (objectId) {
      return `url('/assets/images/wonders/${objectId}-1.jpg')`;
    }
    return `url('/assets/images/wonders/accommodation1.jpg')`;
  }

  goToSheet(id: number): void {
    this.router.navigate([`/sheet/${id}`]);
  }

  goToWondersWithCategory(category: string): void {
    this.router.navigate(['/wonders'], { state: { category } });
  }


  toggleSelectedCategory(id: number) {
    if (this.animating) return;

    const currentSelected = document.querySelector('.category.selectedCategory');
    if (currentSelected && currentSelected.id === id.toString()) {
      return;
    }

    this.animating = true;

    if (currentSelected) {
      currentSelected.classList.remove('selectedCategory');
    }

    const category = document.getElementById(id.toString());
    if (category) {
      category.classList.add('selectedCategory');

      const onTransitionEnd = (e: TransitionEvent) => {
        if (e.propertyName === 'flex-grow' || e.propertyName === 'width') {
          this.animating = false;
          category.removeEventListener('transitionend', onTransitionEnd);
        }
      };

      category.addEventListener('transitionend', onTransitionEnd);
    } else {
      this.animating = false;
    }
  }

}
